import ActiveBookings from '@commons/bookings/active'
import CancelledBookings from '@commons/bookings/cancelled'
import CompletedBookings from '@commons/bookings/completed'
import { Profile } from '@commons/cards/profile'
import Column from '@components/column'
import Tab from '@components/tabs'
import Title from '@components/title'
import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import BusDetails from './bus-details'
import { useSelector } from 'react-redux'
import { RootState } from '@store'
import { Vehicle } from '@apis/index'

const IndividualVehicle = () => {
  const navigate = useNavigate()
  const { state } = useLocation()
  const { data = {} } = useSelector(
    (state: RootState) => state.individualVehicle,
  )

  const fetchVehicle = async () => {
    await Vehicle.find({
      id: state.vehicleId,
      state: 'individualVehicle',
    })
      .then(() => {})
      .catch(() => {})
  }

  const items = [
    { label: 'Bus Details', component: BusDetails, props: { data } },
    {
      label: 'Active Bookings',
      component: ActiveBookings,
      props: { providerId: state ? state?.providerId : '' },
    },
    {
      label: 'Completed Bookings',
      component: CompletedBookings,
      props: { providerId: state ? state?.providerId : '' },
    },
    {
      label: 'Cancelled Bookings',
      component: CancelledBookings,
      props: { providerId: state ? state?.providerId : '' },
    },
  ]
  useEffect(() => {
    if (state?.vehicleId) fetchVehicle()
  }, [state?.vehicleId])
  return (
    <>
      <Column>
        <Title
          textone="Vehicle >"
          texttwo="Details"
          textOneClick={() =>
            navigate(
              `/admin/user-management/providers/${state?.providerId}?tab=Vehicles`,
              { state: state?.providerId },
            )
          }
        />
        <Profile
          user={state?.user}
          isUser={false}
          dashboard={state?.dashboard}
        />
        <Tab items={items} />
      </Column>
    </>
  )
}

export default IndividualVehicle
